import { createFileRoute } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";
import { ScopeOfWorkDetailsPage } from "@/sections/scope-of-works/details";

export const Route = createFileRoute(
  "/dashboard/scope-of-works/$scopeOfWorkId",
)({
  component: Component,
  beforeLoad: ({ context }) => {
    // Viewers get read-only access (CTE-130). The detail page hides every
    // mutation (edit/schedule/cancel/delete/upload/add-equipment) behind a
    // manager-floor `canAccess` check, so a viewer sees a pure read-only SOW.
    requireMinRole(context.session, "viewer");
  },
  staticData: {
    title: "Scope of Work Details",
    parent: { title: "Scope of Works", path: "/dashboard/scope-of-works" },
  },
});

function Component() {
  const { scopeOfWorkId } = Route.useParams();
  return <ScopeOfWorkDetailsPage scopeOfWorkId={scopeOfWorkId} />;
}
